import React from 'react';

// decorative tulip divider inspired by the reference. Uses SVG with watercolor-like fill.
function Tulip({ color = '#e8d36a', delay = 0 }) {
  return (
    <svg
      width="26"
      height="56"
      viewBox="0 0 26 56"
      xmlns="http://www.w3.org/2000/svg"
      className="inline-block"
      style={{ animation: `tulip-bounce 2.6s ease-in-out ${delay}s infinite` }}
    >
      <defs>
        <radialGradient id={`t-${color}`} cx="50%" cy="35%" r="60%">
          <stop offset="0%" stopColor={color} stopOpacity="0.95" />
          <stop offset="100%" stopColor={color} stopOpacity="0.55" />
        </radialGradient>
      </defs>
      <path
        d="M13 2 C 6 10, 4 18, 8 24 C 11 28, 15 28, 18 24 C 22 18, 20 10, 13 2 Z"
        fill={`url(#t-${color})`}
      />
      <path
        d="M13 24 L 13 52"
        stroke="#9ab86a"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13 38 C 10 40, 8 44, 10 48"
        stroke="#9ab86a"
        strokeWidth="1.4"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function Tulips({ colors = ['#e8d36a', '#f3dc78', '#e9c1d5', '#cdb2e0', '#b89dd4'] }) {
  return (
    <div className="flex justify-center items-end gap-4 my-4 select-none">
      {colors.map((c, i) => (
        <Tulip key={i} color={c} delay={i * 0.25} />
      ))}
    </div>
  );
}
